import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { environment } from '../environments/environment';
import { BlankComponent } from './layouts/blank/blank.component';
import { AuthGuard } from './authentication/guard/auth.guard';

var appuri, logouturi, leadupload, voiceupload, audioURL, dncupload, profileUpload, fileupload, gallerydir, recordingdir, tiffdir, pngdir, downloaddir, appurl: string;
if (environment.production) {
  appuri = environment.SERVER;
  logouturi = environment.SERVER + 'logout';
  leadupload = environment.SERVER + 'uploads';
  voiceupload = environment.SERVER + 'uploads';
  profileUpload = environment.SERVER + 'uploads';
  dncupload = environment.SERVER + 'dnc';
  fileupload = environment.SERVER + 'fileupload';
  appurl = environment.SERVERURL;
  gallerydir = environment.SERVERURL + "voicemail/";
  recordingdir = environment.RECORDRURL;
  audioURL = environment.audioURL;

}
else {
  appuri = environment.SERVER;
  logouturi = environment.SERVER + 'logout';
  leadupload = environment.SERVER + 'uploads';
  voiceupload = environment.SERVER + 'uploads';
  profileUpload = environment.SERVER + 'uploads';
  dncupload = environment.SERVER + 'dnc';
  fileupload = environment.SERVER + 'fileupload';
  appurl = environment.SERVERURL;
  gallerydir = environment.SERVERURL + "voicemail/";
  recordingdir = environment.RECORDRURL;
  audioURL = environment.audioURL;

}

export const APIURL = appuri;
export const audiovPath = environment.audioURL
export const LogoutURL = logouturi;
export const LeadsUpload = leadupload;
export const VoiceUpload = voiceupload;
export const ProfileUpload = profileUpload;
export const DncUpload = dncupload;
export const FileUpload = fileupload;
export const AUDIOURL = appurl;
export const RecordingUrl = recordingdir;
export const GalleryPath = gallerydir;
export const audiovoiceupload = environment.SERVER + "audiovoiceupload"
export const audiovoiceupdate = environment.SERVER + "audiovoiceupdate"

export const AppRoutes: Routes = [
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        loadChildren: './authentication/authentication.module#AuthenticationModule'
      }]
  },
  // {
  //   path: '',
  //   component: BlankComponent,
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: 'clientcalendar',
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: 'clientcalendar',
  //       loadChildren: './clientcalendar/clientcalendar.module#ClientcalendarModule'
  //     }]
  // },
  
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    children: [{
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },

    {
      path: 'dashboards',
      loadChildren: './dashboards/dashboard.module#DashboardModule'
    },
    {
      path: 'dashboardsetting',
      loadChildren: './dashboardsetting/dashboardsetting.module#DashboardsettingModule'
    },
    {
      path: 'setting',
      loadChildren: './setting/setting.module#SettingModule'
    },
    {
      path: 'livereport',
      loadChildren: './livereport/livereport.module#LivereportModule'
    },
    {
      path: 'calendar',
      loadChildren: './calendar/calendar.module#CalendarsModule'
    },
    {
      path: 'crm',
      loadChildren: './dialer/dialer.module#DialerModule'
    },
    {
      path: 'lead',
      loadChildren: './lead/lead.module#LeadModule'
    },
    {
      path: 'kyc',
      loadChildren: './kyc/kyc.module#KycModule'
    },
    /* {
     path: 'careerlead',
     loadChildren: './careerlead/careerlead.module#CareerleadModule'
    },
    {
     path: 'autolead',
     loadChildren: './autolead/autodealer.module#AutodealerModule'
    },
    {
     path: 'mortgagelead',
     loadChildren: './mortgagelead/mortgagelead.module#MortgageleadModule'
    }, */
    {
      path: 'userslist',
      loadChildren: './userslist/userslist.module#UserslistModule'
    },
    {
      path: 'ivrsetting',
      loadChildren: './ivr/ivr.module#IvrModule'
    },

    {
      path: 'smssetup',
      loadChildren: './smssetup/smssetup.module#SmssetupModule'
    },

    {
      path: 'callerid',
      loadChildren: './callerid/callerid.module#CalleridModule'
    },

    {
      path: 'voicedrops',
      loadChildren: './voicedrops/voicedrops.module#VoicedropsModule'
    },

    {
      path: 'phonescript',
      loadChildren: './phonescript/phonescript.module#PhonescriptModule'
    },

    {
      path: 'template',
      loadChildren: './template/template.module#TemplateModule'
    },

    {
      path: 'package',
      loadChildren: './package/package.module#PackageModule'
    },
    {
      path: 'topuppackage',
      loadChildren: './topuppackage/topuppackage.module#TopuppackageModule'
    },
    {
      path: 'mangcampaign',
      loadChildren: './mangcampaign/mangcampaign.module#MangcampaignModule'
    },
    {
      path: 'addminutes',
      loadChildren: './addminutes/addminutes.module#AddminutesModule'
    },
    {
      path: 'autodialblok',
      loadChildren: './autodialblok/autodialblok.module#AutodialblokModule'
    },
    {
      path: 'template',
      loadChildren: './template/template.module#TemplateModule'
    },
    {
      path: 'account',
      loadChildren: './account/account.module#AccountModule'
    },
    {
      path: 'agent-groups',
      loadChildren: './agent-groups/agent-groups.module#AgentGroupsModule'
    },
    {
      path: 'profile',
      loadChildren: './profile/profile.module#ProfileModule'
    },
    // {
    //   path: 'package',
    //   loadChildren: './package/package.module#PackageModule'
    // },
    {
      path: 'payment',
      loadChildren: './payment/payment.module#PaymentModule'
    },

    {
      path: '',
      loadChildren: './newreport/report.module#ReportModule'
    },

    {
      path: 'report',
      loadChildren: './report/report.module#ReportModule'
    },

    {
      path: 'automation',
      loadChildren: './automation/automation.module#AutomationModule'
    },
    /* {
      path: 'careerreport',
      loadChildren: './careerreport/careerreport.module#CareerreportModule'
    },
    {
      path: 'autoreport',
      loadChildren: './autoreport/autoreport.module#AutoreportModule'
    },
    {
      path: 'mortgagereport',
      loadChildren: './mortgagereport/mortgagereport.module#MortgagereportModule'
    },   */
    {
      path: 'registration',
      loadChildren: './registration/registration.module#RegistrationModule'
    },
    {
      path: 'signupemail',
      loadChildren: './signupemail/signupemail.module#SignupemailModule'
    },
    {
      path: 'smschat',
      loadChildren: './smschat/smschat.module#SmschatModule'
    },
    {
      path: 'addcampaign',
      loadChildren: './addcampaign/addcampaign.module#AddcampaignModule'
    },
    {
      path: 'calendarsetting',
      loadChildren: './clientcalendar/clientcalendar.module#CalendarsettingModule'
    },

    ]
  }];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes), NgbModule.forRoot()],
  exports: [RouterModule]
})
export class AppRoutingModule { }


